function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { withTheme } from 'styled-components';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { H1 } from '@finect/tabular-core/Headings';
import { ContentProductsCarousel, ProductsCarousel } from '@finect/tabular-components/Products';
import { Head } from '@finect/tabular-components/Head';
import { Container } from '@finect/tabular-core/Container';
import { ContainerInner } from '@finect/tabular-core/ContainerInner';
import { MainContent } from '@finect/tabular-core/MainContent';
import { FundTopYTDFunds, FundMostViewedFunds, FundSectorsCarousel } from '@finect/tabular-components/Modules';
import { getProductTypeBySlug, getFundsHomePath } from '@finect/front-resources/Products';
import { DatalayerScene } from '@finect/front-gtm';
import { Section } from '@finect/tabular-components/Section';
import { VideosCarousel } from '@finect/tabular-components/Videos';
import { withSubscriptions } from '@finect/front-core/User';
import { FamilyInsideNavigation, ProductFamilyContents, SectionBlockContent, SectionBlock } from '../commons/IIC/components';
import { modelizeVideo } from '../commons/videos';
import { setProductRequest } from '../commons/store/products/actions';
import { fetchIICHomeInitialData, clearIICHome } from '../commons/IIC/actions/thunks';
const mapStateToProps = state => ({
  user: state.user.user,
  subscriptions: state.user.subscriptions.products,
  status: state.fund.homeStatus,
  fundsByYTD: state.fund.fundsByYTD,
  fundsByAssets: state.fund.fundsByAssets,
  categories: state.fund.categories,
  managementCompanies: state.fund.managementCompanies,
  topGlobalFunds: state.fund.topGlobalFunds,
  fundsMostViewed: state.fund.mostViewed,
  storeFrontArticles: state.products.storeFrontArticles,
  tag: state.content.tag,
  tags: state.content.tags,
  contentHash: state.content.hash,
  products: state.products.products
});
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    fetchIICHomeInitialData,
    clearIICHome,
    setProductRequest
  }, dispatch)
});
class ETFsHome extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "handleFollow", (product, follow) => {
      this.props.handleEntityFollow('product', 'subscribe', product, follow);
    });
    _defineProperty(this, "handleProductRequest", product => {
      this.props.actions.setProductRequest(product);
    });
  }
  static loadInitialData(store) {
    const productType = getProductTypeBySlug('etfs');
    return store.dispatch(fetchIICHomeInitialData({
      productType
    }));
  }
  componentDidMount() {
    const productType = getProductTypeBySlug(this.props.match.params.typeSlug);
    if (productType.id !== this.props.status) {
      this.props.actions.fetchIICHomeInitialData({
        productType
      });
    }
  }
  componentWillUnmount() {
    this.props.actions.clearIICHome();
  }
  render() {
    const productType = getProductTypeBySlug(this.props.match.params.typeSlug);
    const {
      theme,
      subscriptions,
      fundsMostViewed,
      storeFrontArticles
    } = this.props;
    const tag = this.props.tags.find(item => item.model.alias === productType.tag);
    const container = tag ? `tag-${tag.model.alias}` : null;
    const productsContainerData = this.props.products[container];
    return React.createElement(React.Fragment, null, React.createElement(Head, {
      title: productType.plural,
      description: productType.plural,
      canonical: getFundsHomePath(theme, productType)
    }), React.createElement(DatalayerScene, {
      pageType: "home",
      pageId: productType.api
    }), React.createElement(Container, null, React.createElement(FamilyInsideNavigation, {
      current: "home",
      productType: productType
    }), React.createElement(ContainerInner, null, React.createElement(MainContent, {
      fullWidth: true,
      style: {
        marginTop: '60px'
      }
    }, React.createElement("header", {
      style: {
        marginBottom: '32px'
      }
    }, React.createElement(H1, {
      large: true
    }, productType.plural)), React.createElement(ProductFamilyContents, {
      productType: productType
    }), productsContainerData ? React.createElement(Section, {
      bottomMargin: true
    }, React.createElement(ContentProductsCarousel, {
      distributorsWhiteList: ['FFEEDA6E3F3B11ED920402000AEE01C9'],
      withSPA: true,
      variant: "large",
      products: productsContainerData ? productsContainerData.items : [],
      subscriptions: this.props.subscriptionsProps.subscriptions.products,
      fetching: !productsContainerData,
      onFollow: (id, status, entity) => this.props.handleEntityFollow('product', 'subscribe', id, status, entity),
      onAction: prod => {
        this.handleProductRequest(prod);
      }
    })) : null, React.createElement(ProductsCarousel, {
      title: `${productType.shortPlural} mayores por patrimonio`,
      subtitle: `Los principales etfs por patrimonio`,
      withSPA: true,
      link: {
        href: `${productType.slug}/listado?order=-totalNetAsset`,
        text: `Ver los principales etfs por patrimonio`
      },
      products: this.props.fundsByAssets.items,
      subscriptions: subscriptions || [],
      onFollow: this.handleFollow,
      fetching: this.props.fundsByAssets.fetching
    }), React.createElement(FundTopYTDFunds, {
      withSPA: true,
      productType: productType,
      funds: this.props.fundsByYTD,
      subscriptions: subscriptions,
      onFollow: this.handleFollow
    }), React.createElement(FundSectorsCarousel, {
      productType: productType
    }), React.createElement(VideosCarousel, {
      fetched: !tag ? false : tag.videos.fetched,
      fetching: !tag ? true : tag.videos.fetching,
      title: `${productType.plural} en modo vídeo`,
      videos: tag ? tag.videos.items.map(item => modelizeVideo(item)) : []
    }), React.createElement(FundMostViewedFunds, {
      withSPA: true,
      productType: productType,
      funds: fundsMostViewed,
      subscriptions: subscriptions,
      onFollow: this.handleFollow
    }), tag && (storeFrontArticles || []).map((article, index) => React.createElement(SectionBlockContent, {
      key: index
    }, React.createElement(SectionBlock, {
      article: article,
      tag: tag.model,
      index: index
    })))))));
  }
}
export default withSubscriptions(connect(mapStateToProps, mapDispatchToProps)(withTheme(ETFsHome)), ['products']);